<template>
	<div style="height:100%">
		<div class="table-main">
			<div class="main-head">
				<div>奖金周期</div>
				<div>奖金周期类型</div>
				<div>结算单生成日期</div>
				<div>结算单确认日期</div>
				<div>是否已确认</div>
				<div>详情</div>
			</div>
			<z-scrollDiv class="main-wrap">
				<div class="main-item" v-for="item in dataList" :key="item.id">
					<div>{{ item | cycleStr }}</div>
					<div>{{ item.distribute_type | CycleTypeText }}</div>
					<div>{{ item.created_at }}</div>
					<div>{{ item.confirm_time?item.confirm_time:"-- --" }}</div>
					<div>{{ item.confirm_time?"是":"否" }}</div>
					<div class="end-func" :class="{red:!item.confirm_time}" @click="showBill(item)">{{ item.confirm_time? '详情':'结算' }}</div>
				</div>
				<z-noData :list="dataList"></z-noData>
			</z-scrollDiv>
		</div>

		
		<!-- 账单详情 -->
		<el-dialog  class="z-bill" title="结算账单" :size="'large'"  :visible.sync="billFlag">
			<div class="bill-table">
				<div class="head">
					<div>奖金周期</div>
					<div>快币类型</div>
					<div>数量</div>
					<div>当期汇率</div>
					<div>金额</div>
					<!-- <div>详情</div> -->
				</div>
				<div class="item" v-for="(item,index) in billList" :key="item.id">
					<div>{{ index==0?item:"" | cycleStr }}</div>
					<div>{{ item.currency_name }}</div>
					<div>{{ item.trans_amount+'币' }}</div>
					<div>{{ item.currency_rate }}</div>
					<div>{{ item | ticket_curr }}</div>
					<!-- <div>{{ item.remark }}</div> -->
				</div>
				<div class="item deviate" v-if="bill.periodCurrPersonalSummary && bill.periodCurrPersonalSummary.confirm_money < 0">
					<div>上期结余</div>
					<div>{{ bill.periodCurrPersonalSummary | bonus }}</div>
				</div>
				<div class="item deviate">
					<div>合计</div>
					<div>{{ bill.currPersonalSummary | bonus }}</div>
				</div>


			</div>
	
			<div slot="footer" class="dialog-footer" v-show="!confirmTime">
				<el-button @click="billFlag = false">取 消</el-button>
				<el-button type="primary" :loading="bill_loading" @click="bill_confirm">确认</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script type="text/ecmascript-6">
import { mapGetters, mapState } from 'vuex'

export default {
	props: ["dataList"],
	data() {
		return {
			bill:{},  //账单数据
			// lastData:[],  //上期结余 数组形式，只有一个元素
			total:0,   //结算的合计
			confirmId:"",  //结算确认id
			confirmTime:"",  //结算时间

			billFlag:false,  //账单弹窗
			bill_loading:false,  //确认loading

			questionShow: false,
		}
	},
	computed: {
		billList(){
			// this.bill.list && this.bill.list.forEach((item,index)=>{
			// 	if(item.detail_type==20){
			// 		// item.curr_rate_detail.currency_rate_yuan = "-"+item.curr_rate_detail.currency_rate_yuan;
			// 		item.trans_amount_yuan = "-"+item.trans_amount_yuan;
			// 	}else if(item.detail_type==30){
			// 		this.lastData = this.bill.splice(index,1);
			// 	}
			// })
			return this.bill.list || [];
		},
	},

	filters:{
		CycleTypeText(type){
			const strObj = {
				10: "每月",
				20: "每季度", 
				30: "半年", 
				40: "每年",
			}
			return strObj[type];
		}
	},

	methods: {
		showBill(item) {  //展示账单
			let cycleId = item.cycle_detail_id;
			// this.total = item.confirm_money_yuan;
			this.confirmId = item.id;
			this.confirmTime = item.confirm_time;
			let url = `api/clerk/curr_personal_detail/${item.id}`;
			this.$http.get(url,{
				params:{
					cycle_detail_id:cycleId,
				}
			}).then(res => {
				if(res.status == 200){
					this.bill = res.res_data;
					this.billFlag = true;
				}
			}).catch();
		},
		bill_confirm(){  //账单确认
			this.bill_loading = true;
			let url = `api/clerk/curr_personal_summary_detail/confirmed/${this.confirmId}`;
			this.$http.post(url).then(res=>{
				this.successTip("结算成功");
				this.billFlag = false;
				this.bill_loading = false;
				this.$emit("bigFresh");
			}).catch(error=>{
				this.errorTip("结算失败");
				this.bill_loading = false;
			});
			
		},
	},


}
</script>

<style lang="less" scoped>
@import "~src/assets/less/var.less";
.end-func {
	cursor: pointer;
	color: #4a90e2;
	&.red {
		color: #ff6b6b;
	}
}

.z-bill{
	.el-dialog__body {
		padding: 0;
		// min-height: 220px;
	}
}

.table-main{
	@paddL:30px;
	height:calc(~"100% - @{page-h}");
	.main-head,.main-item{
		box-sizing: border-box;
		padding-left: @paddL;
		&:after{
			content:"";
			display: block;
			clear: both;
		}

		>div{
			float: left;
			width: 15%;
			&:nth-of-type(6){
				max-width: 25%;
			}
		}
	}

	.main-head{
		height: 34px;
		line-height: 34px;
		background: #f2f2f2;
		font-size: 14px;
		color: #333;
	}

	.main-item{
		color:#808080;
		font-size: 12px;
		height: 40px;
		line-height: 39px;
		box-sizing: border-box;
		border-bottom: 1px solid #e6e6e6;
	}

	.main-wrap{
		height: calc(~"100% - 34px + 1px");
		overflow: auto;
	}

}
</style>

<style lang="less">
.bill-table{
	@leftP:30px;
	@leastW:13%;

	margin-bottom: 30px;
	.head,.item{
		zoom:1;
		border-bottom: 1px solid #e6e6e6;
		height: 40px;
		line-height: 39px;
		box-sizing: border-box;
		padding-left: @leftP;
		&:after{
			content:"";
			display:block;
			clear: both;
		}

		>div{
			float: left;
			text-align: center;
			height: 100%;
			&:nth-of-type(1){
				width: @leastW;
				text-align: left;
			}
			&:nth-of-type(2){
				width: @leastW;
			}
			&:nth-of-type(3){
				width: @leastW;
			}
			&:nth-of-type(4){
				width: @leastW;
			}
			&:nth-of-type(5){
				width: @leastW;
			}
			&:nth-of-type(6){
				text-align: left;
				padding-left: @leftP;
				max-width: 100% - @leastW*5;
			}
		}

		&.item-total{
			color:#333;
			font-weight:600;
			>div:nth-of-type(1){
				padding-left: 3 * @leastW;
				width: @leastW;
				text-align: center;
			}
			>div:nth-of-type(2){
				width: @leastW;
			}
		}
	}

	.head{
		font-size: 14px;
		color: #333;
		font-weight: 600;
	}

	.item{
		font-size: 12px;
		color: #808080;
		&.deviate{
			// padding-left: 3*@leastW + @leftP;
			>div:first-child{
				margin-left: 3*@leastW;
				font-size: 14px;
				color: #333;
				font-weight: 600;
				text-align: center;
			}
		}
	}
}
</style>





// WEBPACK FOOTER //
// accountsTable.vue?734b5f6d